import { Box, BoxProps, Flex, Radio } from "@chakra-ui/react";
import { AnimatePresence } from "motion/react";
import { MotionBox } from "src/components/base";
import { USER_REACTION_OPTION_RESULT_TEST_ID, USER_REACTION_OPTION_TEST_ID } from "src/components/user-reactions/user-reaction-bar-test-ids";

interface IUserReactionOption extends BoxProps {
    value: string;
    percentage: number;
    onClick: () => void;
    text?: string;
    isPreview?: boolean;
    isPreviewClickable?: boolean;
    hideBar?: boolean;
    cursor?: "default" | "pointer" | "not-allowed";
}

export const UserReactionOption = ({
    text = "",
    value,
    percentage,
    onClick,
    isPreview,
    isPreviewClickable,
    hideBar = false,
    cursor = "default",
    ...props
}: IUserReactionOption) => {
    return (
        <Flex justifyContent="flex-end" flexDirection="column" width="100%">
            <Flex
                data-test-id={`${USER_REACTION_OPTION_TEST_ID}-${value}`}
                height="50px"
                border="1px solid white"
                alignItems="end"
                position="relative"
                cursor={cursor}
                onClick={() => !isPreview && onClick()}
            >
                <Radio
                    onClick={e => e.preventDefault()}
                    position="absolute"
                    value={value}
                    top="50%"
                    left="50%"
                    marginLeft={-2}
                    marginTop={-2}
                    isReadOnly={isPreview}
                    cursor={cursor}
                />
                {hideBar ? null : (
                    <AnimatePresence initial={!isPreview}>
                        <MotionBox
                            data-test-id={USER_REACTION_OPTION_RESULT_TEST_ID}
                            transition={{ bounce: 2 }}
                            animate={{ height: percentage ? `${percentage}%` : 0 }}
                            backgroundColor={props.backgroundColor}
                            width="100%"
                        ></MotionBox>
                    </AnimatePresence>
                )}
            </Flex>

            <Box height="21px" color="white" {...props} fontSize="sm" fontWeight="semibold" textAlign="center" cursor={cursor}>
                {text}
            </Box>
        </Flex>
    );
};
